module.exports = __webpack_public_path__ + "media/images/emblems/Rubigen-coat_of_arms-c7aa990fd4565e8614ef693fb4cd9b5d.svg";